import type { VNode } from 'vue'

const VNodes = (props: { vnodes: VNode[] }) => {
  return props.vnodes
}

VNodes.props = ['vnodes']

export default VNodes
